import 'jquery-validation';
import 'js-snackbar/snackbar.css';
import { show } from 'js-snackbar';

$(document).ready(function () {
const form = document.querySelector('form');
form ? jvalid() : false;

});

$(window).on('load', function() {
    if (typeof textWarn !== 'undefined') {
        if (textWarn.length) {
            show({
                pos: 'bottom-right',
                backgroundColor: typeWarn,
                text: textWarn,
                duration: 7000,
            });
        }
    }
});

function jvalid() {
    $('form input,form textarea').on('input', function() {
        $('.g-recaptcha').css('opacity', 1);

    });
    var checkbox = $("#checkbox2");
    checkbox.on('click', function() {
        if (checkbox.is(':checked')) {
            $('button[type="submit"]').removeAttr('disabled');
        } else {
            $('button[type="submit"]').attr('disabled', 'disabled');
        }

    });
    jQuery.extend(jQuery.validator.messages, {
        required: 'Pole wymagane',
        email: 'Podaj poprawny email',
        number: 'Podaj poprawny numer',
        maxlength: jQuery.validator.format("Proszę wprowadzić nie więcej niż {0} znaków."),
    });

    $("#commentForm").validate({
        errorElement : 'div',
        errorPlacement: function(error, element) {
            var placement = $(element).data('error');
            if (placement) {
                $(placement).append(error)
            } else {
                error.insertBefore(element);
            }
        }
    });
    $("#form_platnosci").validate({
        errorElement : 'div',
        errorPlacement: function(error, element) {
            var placement = $(element).data('error');
            if (placement) {
                $(placement).append(error)
            } else {
                error.insertBefore(element);
            }
        }
    });

    $("#form_liczniki").validate({
        errorPlacement: function(error, element) {
            var placement = $(element).data('error');
            if (placement) {
                $(placement).append(error)
            } else {
                error.insertBefore(element);
            }
        }
    });
}